import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "uploadArea", "selectedFile", "fileName", "fileStatus"]

  handleDragOver(event) {
    event.preventDefault()
    if (this.hasUploadAreaTarget) this.uploadAreaTarget.classList.add('dragover')
  }

  handleDragLeave(event) {
    event.preventDefault()
    if (this.hasUploadAreaTarget) this.uploadAreaTarget.classList.remove('dragover')
  }

  handleDrop(event) {
    event.preventDefault()
    if (this.hasUploadAreaTarget) this.uploadAreaTarget.classList.remove('dragover')
    const files = event.dataTransfer.files
    if (files.length && this.hasInputTarget) {
      this.inputTarget.files = files
      this.handleChange()
    }
  }

  handleChange() {
    const file = this.hasInputTarget && this.inputTarget.files[0]
    if (file) {
      if (this.hasFileNameTarget) this.fileNameTarget.textContent = file.name
      if (this.hasSelectedFileTarget) this.selectedFileTarget.classList.remove('d-none')
      if (this.hasFileStatusTarget) this.fileStatusTarget.classList.add('d-none')
      if (this.hasUploadAreaTarget) this.uploadAreaTarget.classList.add('has-file')
    }
  }

  removeFile() {
    if (this.hasInputTarget) this.inputTarget.value = ''
    if (this.hasSelectedFileTarget) this.selectedFileTarget.classList.add('d-none')
    if (this.hasFileStatusTarget) this.fileStatusTarget.classList.remove('d-none')
    if (this.hasUploadAreaTarget) this.uploadAreaTarget.classList.remove('has-file')
  }
}
